/**
 * @param {Event} event
 * @param {string} targetSectionID - ID of section you want to scroll to
 * @param {number} scrollOffset - how many pixels to offset the final scroll position
 */
const scrollToSection = (event = null, targetSectionID, scrollOffset) => {
    if (event) {
        // Prevent the default link behavior
        event.preventDefault();
    }

    // Get the position of the targeted section relative to the top of the document
    const target = document.querySelector(`#${targetSectionID}`);
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;

    // Get the height of any fixed elements at the top of the page
    const header = document.querySelector('header');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;

    // Subtract the height of any fixed elements from the target position to get the correct offset
    const offset = targetPosition - headerHeight - scrollOffset;

    // Scroll smoothly to the targeted section
    // using setTimeout here because I think the browser takes a while to recalculate the values above
    // without setTimeout, scrolling back and forth quickly and then calling this function causes it to bug out
    setTimeout(() => {
        window.scrollTo({
            top: offset,
            behavior: 'smooth'
        });
    }, 300);
}



/**
 * @param {string} query - Query for querySelector()
 */
const normalizeHeight = (query) => {
    document.addEventListener('DOMContentLoaded', () => {
        const elements = document.querySelectorAll(query);
        let tallestHeight = 0;

        elements.forEach((element) => {
            const elementHeight = element.offsetHeight;

            if (elementHeight > tallestHeight) {
                tallestHeight = elementHeight;
            }
        })

        elements.forEach((element) => {
            element.style.minHeight = `${tallestHeight}px`;
        })
    })
}


/**
 * Adjust toggles on knowledge expansion - page.rna.liquid page.learning-center-microbiomics.liquid
 */

$(document).ready(function() {
    $('.category-expand-btn').click(function() {
        $('.category-expand-hide').toggle();
        $('.category-expand-show').toggle();

        let subResourcesHeight = $('.sub-resources').height()
        subResourcesHeight == 0 ? $('.sub-resources').css("height", "100%") : $('.sub-resources').css("height", "0")

        $('results-container__inner').slick("refresh");
    })
})


/**
 * RNA PRODUCT BROWSER - SCRIPTS AND STYLES - page.rna.liquid
 */
$(document).ready(function() {

    $('.product-browser-select').on("click", function() {
        const clickedID = $(this).attr('id').split('select-')[1];

        // display tab
        $('.product-browser-select').removeClass('active')
        $(this).addClass('active');

        $('.product-browser-container').hide();
        $(`#${clickedID}`).show();
        $('.product-browser-resources-carousel').slick("refresh");
    })


    // code below turns product browser tabs to accordions in mobile
        function handleWindowResize() {
        const windowWidth = $(window).width();

        if (windowWidth <= 768) {
            $('.product-browser-container').show();
            let contentWrapper = $(this).siblings('.product-browser-content-wrapper');
        
            // Toggle the visibility of the found .product-browser-content-wrapper
            contentWrapper.slideToggle();
        } else {
            $('.product-browser-container').removeAttr('style')
            $('.product-browser-container.active').find(".product-browser-content-wrapper").show()
        }
        }

        handleWindowResize();

        $(window).on('resize', handleWindowResize)

        const windowWidth = $(window).width();

    if(windowWidth <= 768) {
        $('.product-browser-selector-container').click(function() {
        let contentWrapper = $(this).siblings('.product-browser-content-wrapper');
        
        // Toggle the visibility of the found .product-browser-content-wrapper
        contentWrapper.slideToggle();
        $('.product-browser-resources-carousel').slick("refresh");
        })
    }
})

/**
 * @param {string} selector - element selector, provide class/id of the element to be targeted by querySelector
 * @param {number} debounceDelay - amount of debounce delay for when window is resized
 */

const normalizeHeaderHeight = (() => {
    const findLargestHeaderSize = (elements) => {
        return Math.max(...Array.from(elements, element => element.offsetHeight));
    };

    const setHeaderMinHeight = (targetedEls) => {
        targetedEls.forEach(targetedEl => targetedEl.style.minHeight = 'auto');
        const minHeight = findLargestHeaderSize(targetedEls);
        targetedEls.forEach(targetedEl => targetedEl.style.minHeight = `${minHeight}px`);
    };

    const debounce = (func, delay) => {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    return (selector, debounceDelay = 300) => {
        console.log('its running')
        const elements = document.querySelectorAll(selector);

        if (!elements.length) {
            console.warn(`No elements found for selector: "${selector}"`);
            return;
        }

        const handleResize = () => {
            setHeaderMinHeight(elements);
        };

        const debounceResizeMinHeight = debounce(handleResize, debounceDelay);

        setHeaderMinHeight(elements);

        // Add resize event listener
        window.addEventListener("resize", debounceResizeMinHeight);
    };
})();

